export default "__VITE_ASSET__BIqG8r3Y__"